import '../../assets/components/ReadMore/readmore.css';const e = "_readmore_1w8bl_1", d = "_hidden_1w8bl_6", n = "_readmoreExpand_1w8bl_12", o = "_expandButton_1w8bl_15", a = {
  readmore: e,
  hidden: d,
  readmoreExpand: n,
  expandButton: o
};
export {
  a as default,
  o as expandButton,
  d as hidden,
  e as readmore,
  n as readmoreExpand
};
